export const paginationStyles = {
  buttons: "buttons",
  numbers: "numbers",
};